import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'kon-boolean-column',
  standalone: true,
  imports: [CommonModule, CheckboxModule, FormsModule, ReactiveFormsModule],
  template: `
    <p-checkbox
      ngDefaultControl
      [(ngModel)]="value"
      [binary]="true"
      styleClass="pointer-events-none"
      [label]="value ? 'Áno' : 'Nie'"
      labelStyleClass="pointer-events-none"
    />
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BooleanColumnComponent {
  @Input() value?: boolean;
}
